// extracted by mini-css-extract-plugin
export default {"messageContainer":"gift-message_messageContainer__69d97","giftMessageCheckboxLabel":"gift-message_giftMessageCheckboxLabel__c5ec6"};